<!--
  A picture of the member's brief as the Memory page shows it: one section
  with two lines, and the switch that shares it with mentors, on. It shows an
  example and does nothing.
-->
<template>
  <div
    class="rounded-2xl bg-neutral-50 px-4 py-5 sm:px-6 sm:py-6"
    aria-hidden="true"
  >
    <div
      class="mx-auto max-w-[330px] rounded-2xl bg-white p-4 text-left shadow-[0_14px_34px_rgba(20,31,47,0.16)]"
    >
      <div class="flex items-center justify-between gap-3">
        <div class="text-[13px] font-semibold text-neutral-900">Your brief</div>
        <div class="flex items-center gap-2 text-xs text-neutral-600">
          <EyeIcon class="size-3.5" />
          Your mentors see this
          <span
            class="bg-success-500 flex h-4 w-8 items-center justify-end rounded-full px-0.5"
          >
            <span class="size-3 rounded-full bg-white" />
          </span>
        </div>
      </div>
      <ul class="mt-3 space-y-2">
        <li
          v-for="line in LINES"
          :key="line"
          class="flex gap-2 text-xs leading-snug text-neutral-600"
        >
          <span class="mt-1.5 size-1 shrink-0 rounded-full bg-neutral-300" />
          {{ line }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import EyeIcon from '~icons/lucide/eye'

const LINES = [
  'What your business is and who it is for.',
  'What you already tried, and how it went.',
  'The one thing you work on now.',
]
</script>
